<template lang='pug'>
  blue-layout( :user='user' :account='account' :biz='biz' )
    template( v-if='account.id' v-slot:default='props' )
      bf-wrapper#schedule.view.content.positioned.no-header
        biz-cal(
          v-if='account.merchant && biz.id'
          :user='user'
          :account='account'
          :biz='biz'
        )

        usr-cal(
          v-else
          :user='user'
          :account='account'
          :biz='biz'
        )
</template>

<script>
  import { View } from '@/mixins/view'
  import BizCal from '@/components/calendars/biz'
  import UsrCal from '@/components/calendars/usr'

  export default {
    name: 'view.schedule',

    mixins: [ View ],

    components: {
      UsrCal,
      BizCal
    }
  }

</script>
